import React, { ReactElement, FC, useEffect, useState, useMemo } from "react";
import { lightTheme, darkTheme } from "./theme";
import { ThemeProvider } from "@emotion/react";
import {
  Button,
  CssBaseline,
  Switch,
  IconButton,
  Tooltip,
} from "@mui/material";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "./hooks/reduxhook";
import { useModels } from "./hooks/useModels";

import "./App.css";

import SnackbarError from "./components/SnackbarError";
import SettingsModal from "./components/SettingsModal";
import Loader from "./components/FullScreenLoader";

import {
  addsettingModal,
  getsettingModalDetails,
} from "./redux/slices/settingSlice";

import NoAccess from "./pages/NoAccess";
import Dashboard from "./pages/Admin";
import Playground from "./pages/Playground";
import Login from "./pages/Login";
import SnackbarSuccess from "./components/SnackbarSuccess";
import { NotFound } from "./components/NotFound";
import { brandingSettings } from "./branding";
const App: FC<any> = (): ReactElement => {
  const settingsModalOpen = useAppSelector(getsettingModalDetails);
  const dispatch = useAppDispatch();

  const { instance, accounts } = useMsal();
  const userAccount = accounts[0];
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const { isLoading, error } = useModels(userAccount);

  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    return savedTheme === "dark";
  });
  const theme = useMemo(
    () => (isDarkMode ? darkTheme : lightTheme),
    [isDarkMode]
  );
  const logoUrl = brandingSettings.logoPath;
  const handleThemeToggle = () => {
    setIsDarkMode((prev) => {
      const newTheme = !prev;
      localStorage.setItem("theme", newTheme ? "dark" : "light");
      return newTheme;
    });
  };

  useEffect(() => {
    const func = async () => {
      if (userAccount?.idTokenClaims) {
        if (
          userAccount?.idTokenClaims?.exp ??
          Math.ceil(Date.now() - 1 / 1000) < Math.ceil(Date.now() / 1000)
        ) {
          await instance.initialize();

          await instance.acquireTokenSilent({
            scopes: [
              window.__RUNTIME_CONFIG__.REACT_APP_AAD_APP_SCOPE ?? "User.Read",
            ],
            account: userAccount,
          });
        }
      }
    };
    func();
  }, [userAccount, instance]);
  useEffect(() => {
    const updateOnlineStatus = () => {
      setIsOnline(navigator.onLine);
    };

    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, []);

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {/* <div style={{position: 'fixed', zIndex: '9999', right: '5px', top: '10px'}}>
            <Tooltip title={theme.palette.mode === 'dark' ? "Light Mode" : "Dark Mode"}>
              <IconButton onClick={handleThemeToggle} color="inherit" >
                {isDarkMode ? <Brightness7Icon />  : <Brightness4Icon />}
              </IconButton>
            </Tooltip>
          </div> */}

        <UnauthenticatedTemplate>
          <Router>
            <Routes>
              <Route path="*" element={<Login />} />
            </Routes>
          </Router>
        </UnauthenticatedTemplate>
        <AuthenticatedTemplate>
          <Router>
            <Routes>
              <Route path="/" element={<Playground logoUrl={logoUrl} />} />
              <Route path="/noaccess" element={<NoAccess />} />
              <Route path="/admin" element={<Dashboard />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Router>
          <SettingsModal
            open={settingsModalOpen}
            setOpen={(e: any) => dispatch(addsettingModal(e))}
          />
        </AuthenticatedTemplate>
        <SnackbarError />
        <SnackbarSuccess />
        {/* <Loader /> */}
      </ThemeProvider>
    </>
  );
};

export default App;
